import styled from "styled-components"
import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { MtDriveVersion } from "server/models"
import { deepCopy } from "client/utils"
import {
    StoreType,
    QidDatapointChanges,
    setQidDatapointChanges,
} from "client/store"
import {
    Empty,
    ConfirmWrapper,
    Confirm,
    ConfirmDescription,
    ButtonGroup,
    ButtonGroupItem,
} from "client/components"


const TableSelectParentStyled = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 8px 12px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    
    & > div > div { // styled "Confirm"
        padding: 15px;
        padding-bottom: 0;
        min-height: unset;
    }
`

const TitleWrapper = styled.div`
    padding-bottom: 8px;
`

interface SelectProps {
    data: MtDriveVersion
}

const TableSelect = ({
    data,
}: SelectProps) => {
    const referenceList = useSelector((state: StoreType) => state.qidDatapoint.referenceList)
    const activeCell = useSelector((state: StoreType) => state.qidDatapoint.activeCell)
    const changes = useSelector((state: StoreType) => state.qidDatapoint.changes)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [showModal, setShowModal] = useState(true)
    const [reference, setReference] = useState(data)

    useEffect(() => {
        const changesCopy: QidDatapointChanges = deepCopy(changes)
        if (!changesCopy[activeCell.datapointId]) {
            changesCopy[activeCell.datapointId] = {}
        }
        changesCopy[activeCell.datapointId] = {
            ...changesCopy[activeCell.datapointId],
            reference,
        }
        dispatch(setQidDatapointChanges(changesCopy))
    }, [reference])

    const selectReference = (e: React.MouseEvent<HTMLDivElement, MouseEvent>, ref: MtDriveVersion) => {
        e.stopPropagation()
        setReference(ref)
        setShowModal(false)
    }

    const referenceTitle = reference ? `${reference.file.name} - rev. ${reference.revision}` : null

    return (
        <TableSelectParentStyled
            onClick={() => setShowModal(true)}
            title={referenceTitle || lang.empty}
        >
            { referenceTitle || <Empty /> }

            <ConfirmWrapper
                show={showModal}
                onClose={() => setShowModal(false)}
            >
                <Confirm>
                    <ConfirmDescription>
                        <TitleWrapper>{lang.selectReference}</TitleWrapper>

                        <ButtonGroup>
                            <ButtonGroupItem
                                active={reference === null}
                                onClick={(e) => selectReference(e, null)}
                            >
                                <Empty />
                            </ButtonGroupItem>
                            {
                                referenceList.map((file) => (
                                    file.versions.map((version) => (
                                        <ButtonGroupItem
                                            key={version.id}
                                            active={reference && reference.id === version.id}
                                            onClick={(e) => selectReference(e, { ...version, file })}
                                        >
                                            {`${file.name} - rev. ${version.revision}`}
                                        </ButtonGroupItem>
                                    ))
                                ))
                            }
                        </ButtonGroup>
                    </ConfirmDescription>
                </Confirm>
            </ConfirmWrapper>
        </TableSelectParentStyled>
    )
}
export default TableSelect
